import React from 'react';
import Widget from 'components/Widget/Widget';
import PostbackChart from './components/PostbackChart';
import PostbacksFilters from 'modules/DashboardModule/widgets/PostbackQuickReports/components/PostbacksFilters';
import { postbackMetrics } from 'modules/DashboardModule/widgets/PostbackQuickReports/components/Postbackmetrics';

const PostbackReportsChart = ({ height = 500, data, index, configuration }) => {
  return (
    <Widget
      className='w-full bg-white'
      widget_key={'postback_reports_charts' + index}
      filterComponent={PostbacksFilters}
      title={data.title}
      index={index}
      disableLevelFilter
      disableLimit
      disableStatusFilter
      default_filter={data.defaultFilter}
      configuration={configuration}
      metricsList={postbackMetrics}
      data={data}
      load_chart={true}
      showCustomDesign
      disableAccountsFilter
      changeMetricsDesign
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <PostbackChart height={height - 55} />
    </Widget>
  );
};

export default PostbackReportsChart;
